import { Filter } from '../../Enum/Filters';

export const MAX_AMOUNT_SELECTED = 8;

export const FIXED_PERIOD_FILTERS = [
    Filter.ConstructionType,
    Filter.EnergyLabel,
    Filter.FixedPeriods,
    Filter.LoanForm,
    Filter.NHG,
    Filter.RiskCategory,
    Filter.ClientType,
    Filter.Account,
];

export const MARKET_VALUE_FILTERS = [
    Filter.ConstructionType,
    Filter.EnergyLabel,
    Filter.FixedPeriod,
    Filter.LoanForm,
    Filter.NHG,
    Filter.ClientType,
    Filter.Account,
];

export const PRODUCT_FILTERS = [Filter.Label, Filter.ModificationLoanForm, Filter.ConstructionType];

export const PROPERTIES_PER_LABEL_FILTER = [Filter.Labels];

export const PROPERTIES_PER_PROPERTY_FILTER = [Filter.MortgageProperties];

export const NEWS_FILTER = [Filter.NewsLabels, Filter.DateFrom, Filter.DateTo];

export const BRIDGING_LOANS = [Filter.BridgingLoanLabels];
